




import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/store/types';

@Component
export default class WindowWidthResizeListener extends Vue {

  private windowWidth: number = window.innerWidth;

  public mounted() {
    this.$store.commit(Mutations.WindowWidth.setWindowWidth, this.windowWidth);
    window.addEventListener('resize', this.onResize);
  }

  public destroyed() {
    window.removeEventListener('resize', this.onResize);
  }

  private onResize() {
    // catch unnecessary resize events fired on Android and iOS when scrolling
    if (this.windowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth;
      this.$store.commit(Mutations.WindowWidth.setWindowWidth, this.windowWidth);
    }
  }
}
